// Mirrors PFM_US.Domain's PartialSaveTrigger enum member names exactly -- these strings are
// persisted on Funnel/EverFlowAffiliate and serialized as-is over the FunnelDto/EverFlowAffiliateDto
// round-trip, so this file must never drift from the C# names. Asana 1218515159227367.
export enum PartialSaveTrigger {
  OnEntry = 'OnEntry',
  OnStep1Complete = 'OnStep1Complete',
}
